<script setup>
import { computed, defineProps } from 'vue';
import { useLoadingCheck, useModifiers } from '@/app/composables/';

const props = defineProps({
  href: {
    required: true,
    type: String,
  },
  modifiers: {
    default: () => [],
    required: false,
    type: Array,
  },
});
const cssClasses = computed(() => useModifiers('c-button', props.modifiers));
const { loadingPrevent, loadingTabindex } = useLoadingCheck();
</script>

<template>
  <a
    @keydown="loadingPrevent"
    :class="cssClasses"
    :href="props.href"
    :tabindex="loadingTabindex"
    class="c-button"
  >
    <slot />
  </a>
</template>
